import type { Payload } from '@viewport/library-next'

export interface Token {
  email: string
  sub: string
  perms: Payload['perms']
  cid: string
  lng: string | null
  exp: number
}

export function getUserDataFromToken(token: Token) {
  return {
    email: token.email,
    id: token.sub,
    company: token.cid,
    language: token.lng ?? null,
    permissions: token.perms,
    cid: token.cid,
    sub: token.sub,
    perms: token.perms,
    exp: token.exp,
  }
}
